import React from "react";
import ReactDOM from "react-dom";
import { CDN } from "../constants/env";

let reactXarrowsLoaded = false;
let loadingPromise: Promise<void> | null = null;

export type ReactXarrowsWrapperType = {
  Xarrow: React.ComponentType<Record<string, unknown>>;
};

declare global {
  interface Window {
    getVersion: () => string;
    React: typeof React;
    ReactDOM: typeof ReactDOM;
    ReactXarrowsWrapper: ReactXarrowsWrapperType;
  }
}

export const ensureReactXarrowsScriptIsLoaded = async (): Promise<void> => {
  if (reactXarrowsLoaded && window.ReactXarrowsWrapper) return;

  if (loadingPromise) return loadingPromise;

  loadingPromise = new Promise((resolve, reject) => {
    window.React = React;
    window.ReactDOM = ReactDOM;

    const script = document.createElement("script");
    const version = window.getVersion ? window.getVersion() : "main";
    script.src = `${CDN}/stetho/${version || "main"}/react-xarrows-bundle.js`;
    script.onload = () => {
      reactXarrowsLoaded = true;
      resolve();
    };
    script.onerror = () => {
      loadingPromise = null;
      reject(new Error("Failed to load ReactXarrows Script"));
    };
    document.head.appendChild(script);
  });

  return loadingPromise;
};
